import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35ddf25b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NavBar" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]


import { useRoute, useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  props: {
  navList: {
    type: Array as () => Array<any>,
    default: () => []
  },
  type: {
    type: String,
    default: null
  }
},
  setup(__props) {

const props = __props
const route = useRoute()
const router = useRouter()



// 导航栏切换
const changeType = (type: string) => {
  const params: any = {
    ...route.params
  }
  params.type = type
  router.replace({ ...route, params })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.navList, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["NavBar-item", { active: item.value === __props.type }]),
        key: item.value,
        onClick: ($event: any) => (changeType(item.value))
      }, [
        _createElementVNode("img", {
          referrerPolicy: "no-referrer",
          src: item.icon
        }, null, 8, _hoisted_3)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})